import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.0003 38.0006C15.2263 38.0006 10.6479 36.1042 7.27215 32.7285C3.89644 29.3527 2 24.7743 2 20.0003C2 15.2263 3.89644 10.6479 7.27215 7.27215C10.6479 3.89644 15.2263 2 20.0003 2C24.7743 2 29.3527 3.89644 32.7285 7.27217C36.1042 10.6479 38.0006 15.2263 38.0006 20.0003C38.0006 29.8186 31.0459 33.9096 26.5458 38.0006",
      stroke: "#C61736",
      "stroke-width": "3"
    }, null, -1),
    _createElementVNode("path", {
      d: "M33.0915 38.0065H26.5459V31.4609",
      stroke: "#C61736",
      "stroke-width": "3"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20 8.53906V19.9938H28.1819",
      stroke: "#C61736",
      "stroke-width": "3"
    }, null, -1)
  ])))
}
export default { render: render }